export const bonusQueryKeys = {
  rearchBonusAssignments: 'FETCH_BONUS_ASSIGNMENTS_PAY_DETAILS',
  rearchBonusComponentNames: 'FETCH_BONUS_COMPONENT_NAMES',
} as const;
